import { render, staticRenderFns } from "./typeTree.vue?vue&type=template&id=6e2a043a&scoped=true"
import script from "./typeTree.vue?vue&type=script&lang=js"
export * from "./typeTree.vue?vue&type=script&lang=js"
import style0 from "./typeTree.vue?vue&type=style&index=0&id=6e2a043a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a043a",
  null
  
)

export default component.exports